export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            关于我们
          </h2>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="max-w-2xl">
            <p className="text-base md:text-lg leading-relaxed text-foreground-700 mb-4">
              <strong className="text-foreground-900">51cg吃瓜网</strong> 是全网领先的娱乐资讯聚合平台，专注于为吃瓜群众提供
              <strong className="text-primary-600">最新爆料</strong>、
              <strong className="text-primary-600">热门事件追踪</strong>与
              <strong className="text-primary-600">独家消息</strong>。
            </p>
            <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-4">
              平台覆盖娱乐圈、直播圈、网红圈、综艺影视等多个领域，通过多渠道信息采集与专业编辑团队把关，
              确保每一条51今日吃瓜内容都具备时效性与可信度。我们坚持每日更新，立足51吃瓜官网全网最新定位，
              打造最有温度的吃瓜社区，让每一位用户都能在这里找到共鸣与乐趣。
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed">
              自上线以来，51吃瓜网今日吃瓜栏目已累计发布数万条内容，服务超过百万吃瓜用户，
              成为中文互联网最具影响力的娱乐资讯平台之一。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}